module.exports = __webpack_public_path__ + "img/saheli_back1.1fa7a18f.jpg";